// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type GoogleAuth, GoogleAuthCode } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function usePostgoogleAuth(): (
  requestBody: GoogleAuthCode
) => Promise<GoogleAuth> {
  const getAPI = useGetApi();
  return useCallback(
    async (requestBody) =>
      (await getAPI()).externesysteme.postgoogleAuth({ requestBody }),
    [getAPI]
  );
}
